import { Component, Input } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { Chart, ChartOptions } from "chart.js";
import { AlertService } from "../../../_services/alert.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { LocalStorageManagerService } from "../../../_services/localStoageManager.service";
import { LoggerService } from "../../../modules/logger/logger.service";
import { GenericChartScreen } from "../models/GenericChartScreen";
import { ChartService } from "../../../_services/chart.service";

@Component({
  selector: "generic-chart",
  templateUrl: "generic-chart.component.html",
  styleUrls: ["./generic-chart.component.scss"],
})
export class GenericChartComponent {
  public searchQuery: any;
  @Input("chartType") public chartType: GenericChartScreen =
    GenericChartScreen.None;
  public paymentSummeryChartData: any[] = [];
  public paymentSummeryChartLabels: any[] = [];
  public paymentSummeryChartOptions: ChartOptions;
  public paymentSummeryChartColors: Array<{ backgroundColor: string[] }>;
  public opacity: number = 0.5;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private sessionManger: SessionManagerService,
    private localStorageManager: LocalStorageManagerService,
    private logger: LoggerService,
    private chartService: ChartService
  ) {
    this.paymentSummeryChartOptions =
      this.chartService.getPaymentSummaryChartConfig().paymentSummeryChartOptions;
    this.paymentSummeryChartData = [
      7578820.2, 50722, 21430.5, 41897, 461855.80000000005,
    ];
    this.paymentSummeryChartLabels = [
      "שולם",
      "התחייבות",
      "קבלות פתוחות",
      "בקשות החזר בטיפול",
      "בקשות החזר שאושרו",
    ];
    this.paymentSummeryChartColors =
      this.chartService.getPaymentSummaryChartConfig().paymentSummeryChartColors;
  }

  public close() {}

  public async callSearchEvents() {}
}



// WEBPACK FOOTER //
// ./src/app/admin/charts/generic-chart/generic-chart.component.ts